module.exports = __webpack_public_path__ + "static/media/crop.25c9d0c8.svg";